<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="90%"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <OptionalTable
      ref="optionalTable"
      @checkbox-change="onCheckboxChange"
      :orderCode="orderCode"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="confirm()"
        :disabled="notCheck"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import OptionalTable from './table.vue'
export default {
  components: { OptionalTable },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderCode: { type: String, default: '' },
  },
  data() {
    return {
      checkedRow: [],
    }
  },
  computed: {
    notCheck() {
      return !this.checkedRow || !this.checkedRow.length
    },
  },
  methods: {
    onCheckboxChange(e) {
      this.checkedRow = e
    },
    confirm() {
      if (!this.checkedRow) return
      this.$emit('confirm', this.checkedRow)
      this.close()
    },
    close() {
      this.checkedRow = []
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
